import { api, apiRequest } from "./api";
import type {
  PromoCode,
  PromoCodeDetailEnvelope,
  PromoCodeListParams,
  PromoCodePaginatedResponse,
  PromoCodePayload,
} from "@/types/promo-codes";

export async function fetchPromoCodes(
  params?: PromoCodeListParams
): Promise<PromoCodePaginatedResponse> {
  return apiRequest(() =>
    api.get<PromoCodePaginatedResponse>("/internal/promo-codes/", { params })
  );
}

export async function fetchPromoCodeDetail(
  promoCodeId: number
): Promise<PromoCode> {
  const envelope = await apiRequest<PromoCodeDetailEnvelope>(() =>
    api.get<PromoCodeDetailEnvelope>(`/internal/promo-codes/${promoCodeId}/`)
  );
  return envelope.data;
}

export async function createPromoCode(
  payload: PromoCodePayload
): Promise<PromoCode> {
  return apiRequest(() =>
    api.post<PromoCode>("/internal/promo-codes/", payload)
  );
}

export async function updatePromoCode(
  promoCodeId: number,
  payload: PromoCodePayload
): Promise<PromoCode> {
  return apiRequest(() =>
    api.patch<PromoCode>(`/internal/promo-codes/${promoCodeId}/`, payload)
  );
}

export async function deletePromoCode(promoCodeId: number): Promise<void> {
  await apiRequest(() => api.delete(`/internal/promo-codes/${promoCodeId}/`));
}
